import React, { Component } from 'react';
import { Switch } from 'antd';

class SwitchItem extends Component {
  render() {
    return <Switch {...this.props} style={{ transform: 'scale(0.9)' }} />;
  }
}


export default SwitchItem;